export const en = {
    'approve-package': 'todo',
    'reject-package': 'Reject',
    'to-approve': 'todo',
    'to-edit': 'Edit'
};
